import { ChangelogModal as BaseChangelogModal } from '@dreryk/react-components';

import { appTranslationKeys } from '../translations';

type ChangelogModalProps = {
   readonly onOpen: VoidFunction;
   readonly onClose: VoidFunction;
   readonly canOpen: boolean;
};

const ChangelogModal = (props: ChangelogModalProps): JSX.Element | null => {
   const { changelogEndpoint, changelogLink } = window.APP_ENV;

   if (!changelogEndpoint || !changelogLink || !props.canOpen) {
      return null;
   }

   return (
      <BaseChangelogModal
         endpoint={changelogEndpoint}
         changelogLink={changelogLink}
         title={appTranslationKeys.whatsNew}
         testId={'changelog'}
         onOpen={props.onOpen}
         onClose={props.onClose}
      />
   );
};

export { ChangelogModal };
